import * as React from "react"
import * as ToastPrimitives from "@radix-ui/react-toast"
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from "lucide-react"

import { cn } from "../../lib/utils"
import "./toast.css"

const ToastProvider = ToastPrimitives.Provider

// Bildirim ekranın üstünde durur, bu yüzden parmakla **yukarı** itilerek
// kapatılır; Radix'in varsayılan "sağa kaydır" yönü aşağıdan çıkan bir
// bildirimin hareketidir ve burada ters düşerdi.
const TOAST_SWIPE_DIRECTION = "up";

const ToastViewport = React.forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitives.Viewport
    ref={ref}
    className={cn("bhs-toast-viewport", className)}
    {...props} />
))
ToastViewport.displayName = ToastPrimitives.Viewport.displayName

const TONE_ICONS = {
  success: CheckCircle2,
  error: XCircle,
  warning: AlertTriangle,
  info: Info,
};

const ToastIcon = ({ tone = "info" }) => {
  const Icon = TONE_ICONS[tone] || Info;
  return (
    <span className="bhs-toast-icon" aria-hidden="true">
      <Icon strokeWidth={2.2} />
    </span>
  );
};

const Toast = React.forwardRef(({ className, tone = "info", duration, ...props }, ref) => (
  <ToastPrimitives.Root
    ref={ref}
    data-tone={tone}
    duration={duration}
    className={cn("bhs-toast", className)}
    {...props} />
))
Toast.displayName = ToastPrimitives.Root.displayName

const ToastAction = React.forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitives.Action
    ref={ref}
    className={cn("bhs-toast-action", className)}
    {...props} />
))
ToastAction.displayName = ToastPrimitives.Action.displayName

const ToastClose = React.forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitives.Close
    ref={ref}
    className={cn("bhs-toast-close", className)}
    aria-label="Bildirimi kapat"
    toast-close=""
    {...props}>
    <X aria-hidden="true" />
  </ToastPrimitives.Close>
))
ToastClose.displayName = ToastPrimitives.Close.displayName

const ToastTitle = React.forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitives.Title ref={ref} className={cn("bhs-toast-title", className)} {...props} />
))
ToastTitle.displayName = ToastPrimitives.Title.displayName

const ToastDescription = React.forwardRef(({ className, ...props }, ref) => (
  <ToastPrimitives.Description
    ref={ref}
    className={cn("bhs-toast-description", className)}
    {...props} />
))
ToastDescription.displayName = ToastPrimitives.Description.displayName

// Süresiz bildirimde (duration: Infinity) çubuk çizilmez: dolmayan bir sayaç
// kullanıcıya beklemesi gereken bir süre varmış gibi görünürdü.
const ToastProgress = ({ duration }) => {
  if (!Number.isFinite(duration) || duration <= 0) return null;
  return <span className="bhs-toast-progress" style={{ "--bhs-toast-duration": `${duration}ms` }} />;
};

export {
  ToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastAction,
  ToastIcon,
  ToastProgress,
  TOAST_SWIPE_DIRECTION,
};
